<template>
  <div>
    <panorama class="build-panorama" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "assets/styles/fonts";
* {
  margin: 0;
  padding: 0;
}
.build-panorama {
  height: 100vh;
  width: 100vw;
}
svg:not(:root) {
  overflow: visible;
}
</style>
